// extracted by mini-css-extract-plugin
module.exports = {"StepHead":"StepHead_StepHead__u0362","StepHeadLeft":"StepHead_StepHeadLeft__1Zb9h","StepHeadContent":"StepHead_StepHeadContent__1DBCr","HeadBox":"StepHead_HeadBox__3Q9f3"};